import { SQLITE_R2_PATH } from './constants'

/** Fetch SQLite bytes from R2 via allworld static PUT/GET */
export async function fetchSqliteBytes() {
  const res = await fetch(SQLITE_R2_PATH, { cache: 'no-store' })
  if (res.status === 404) return null
  if (!res.ok) throw new Error(`加载 R2 SQLite 失败: HTTP ${res.status}`)
  const ct = res.headers.get('content-type') || ''
  if (ct.includes('text/html')) return null
  return new Uint8Array(await res.arrayBuffer())
}

/** Persist SQLite bytes to R2 (allworld accepts PUT on non-api paths) */
export async function persistSqliteBytes(bytes) {
  const res = await fetch(SQLITE_R2_PATH, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/x-sqlite3' },
    body: bytes,
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`写入 R2 SQLite 失败: HTTP ${res.status} ${text.slice(0, 120)}`)
  }
  return res.json().catch(() => ({ ok: true }))
}

export async function fetchBundledSeedBytes() {
  const res = await fetch(`${SQLITE_R2_PATH}?seed=1`, { cache: 'no-store' })
  if (!res.ok) throw new Error('无法加载内置 SQLite 种子文件')
  return new Uint8Array(await res.arrayBuffer())
}
